import { createAction, props } from '@ngrx/store';

import { ListProductReferenceEntity } from '../models';

export const loadListProductReferences = createAction(
  '[List Product Reference] Set Active Reference',
  props<{ productListId: string }>(),
);

export const upsertListProductReferenceEntity = createAction(
  '[List entities] Upsert list product reference entity',
  props<{ productReferenceEntity: ListProductReferenceEntity }>(),
);

export const upsertManyListProductReferenceEntities = createAction(
  '[List entities] Upsert many list product reference entities',
  props<{ productReferenceEntities: ListProductReferenceEntity[] }>(),
);

export const resetProductReferenceEntities = createAction(
  '[List entities] Reset list product reference entities',
);
